<script>
    export let vertical = 0;
    export let horizontal = 0;
</script>

<div style="padding-top: {vertical}px; padding-left: {horizontal}px" />
